import { jsx } from "react/jsx-runtime";
import { throttle } from "lodash-es";
import Measure from "react-measure";
import PropTypes from "prop-types";
import Browser from "./Browser";
import React from "react";
export default class ReflexElement extends React.Component {
  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  static propTypes = {
    renderOnResizeRate: PropTypes.number,
    propagateDimensions: PropTypes.bool,
    renderOnResize: PropTypes.bool,
    resizeHeight: PropTypes.bool,
    resizeWidth: PropTypes.bool,
    className: PropTypes.string
  };
  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  static defaultProps = {
    renderOnResize: Browser.isSafari(),
    // Safari is creepy ...
    propagateDimensions: false,
    renderOnResizeRate: 60,
    resizeHeight: true,
    resizeWidth: true,
    className: ""
  };
  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  constructor(props) {
    super(props);
    this.onResize = this.onResize.bind(this);
    this.setStateThrottled = throttle((state) => {
      this.setState(state);
    }, this.props.renderOnResizeRate);
    this.state = {
      dimensions: {
        height: "100%",
        width: "100%"
      }
    };
  }
  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  async UNSAFE_componentWillReceiveProps(props) {
    if (props.size !== this.props.size) {
      const directions = this.toArray(props.direction);
      for (const dir of directions) {
        await this.props.events.emit("element.size", {
          size: props.size,
          direction: dir,
          element: this
        });
      }
    }
  }
  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  toArray(obj) {
    return obj ? Array.isArray(obj) ? obj : [obj] : [];
  }
  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  onResize(rect) {
    const { renderOnResize, resizeHeight, resizeWidth } = this.props;
    if (renderOnResize) {
      this.setStateThrottled({
        dimensions: {
          ...resizeHeight && { height: Math.floor(rect.bounds.height) },
          ...resizeWidth && { width: Math.floor(rect.bounds.width) }
        }
      });
    }
  }
  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  renderChildren() {
    if (this.props.propagateDimensions) {
      return React.Children.map(this.props.children, (child) => {
        const newProps = Object.assign({}, child.props, {
          dimensions: this.state.dimensions
        });
        return React.cloneElement(child, newProps);
      });
    }
    return this.props.children;
  }
  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  render() {
    const classNames = ["reflex-element", ...this.props.className.split(" ")];
    const className = classNames.join(" ");
    const outerStyle = Object.assign(
      {},
      {
        WebkitBoxFlex: this.props.flex,
        FlexElement: this.props.flex,
        MozBoxFlex: this.props.flex,
        WebkitFlex: this.props.flex,
        flex: this.props.flex
      },
      this.props.style
    );
    const innerStyle = {
      height: this.state.dimensions.height,
      width: this.state.dimensions.width
    };
    return /* @__PURE__ */ jsx(Measure, { bounds: true, onResize: this.onResize, children: ({ measureRef }) => /* @__PURE__ */ jsx("div", { ref: measureRef, className, style: outerStyle, children: /* @__PURE__ */ jsx("div", { className: "tg-reflex-element-inner", style: innerStyle, children: this.renderChildren() }) }) });
  }
}
